import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import Modal from '../../../../../Modal';
import { T } from '../../../../../../Translations';
import { shareStore } from '../../../Share/Stores/ShareStore';
import AdvancedSettings from '../../../Share/ShareOptionsModal/ShareUrl/AdvancedSettings';

interface Props {
  close: () => void;
  collectionId: number;
}

const AdvancedSettingsModal: React.FC<Props> = ({ close, collectionId }) => {
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    shareStore.load(collectionId, 'url', 'collection', nothing());
  }, [collectionId]);

  const handleSave = () => {
    setSaving(true);
    setError(false);
    shareStore.saveAdvancedSettings().fork(
      () => {
        setSaving(false);
        setError(true);
      },
      () => {
        setSaving(false);
        close();
      },
    );
  };

  const title = (
    <h2 className="font-semibold text-xl text-foreground">
      <T kind="Advanced Settings" />
    </h2>
  );

  return (
    <Modal
      close={close}
      contentPadding="px-1"
      title={title}
      modalWidth="w-[700px] max-w-[700px] overflow-hidden"
    >
      <div className="pt-2 pb-4">
        <AdvancedSettings />
        {error && (
          <p className="mt-2 text-sm text-destructive">
            <T kind="Something went wrong" />
          </p>
        )}
        <div className="mt-8 flex justify-end gap-3">
          <button
            onClick={close}
            className="rounded-md border border-border px-4 py-2 text-sm text-foreground hover:bg-muted"
            data-intercom-target="advanced-settings-cancel-button"
          >
            <T kind="Cancel" />
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            className="rounded-md bg-accent px-4 py-2 text-sm text-accent-foreground hover:bg-accent/90 disabled:opacity-50"
            data-intercom-target="advanced-settings-save-button"
          >
            <T kind="Save" />
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default observer(AdvancedSettingsModal);
